/*eslint no-unused-vars: [0]*/
import {
	FETCH_PRODUCT,
	FETCH_PRODUCT_SUCCESS,
	FETCH_PRODUCT_FAIL,
	FETCH_PRODUCT_CATEGORIES,
	FETCH_PRODUCT_CATEGORIES_SUCCESS,
	FETCH_PRODUCT_CATEGORIES_FAIL,
	FETCH_PRODUCTS,
	FETCH_PRODUCTS_SUCCESS,
	FETCH_PRODUCTS_FAIL,
	SET_PRODUCT_SEARCH_TERM,
	SET_PRODUCT_QUANTITY,
	SHOP_SORT_BY,
	SET_SELECTED_PRODUCT_CATEGORY,
	REMOVE_PRODUCT_FROM_CART,
	FETCH_PRODUCT_BUNDLES,
	FETCH_PRODUCT_BUNDLES_SUCCESS,
} from '../constants/ActionTypes';

export const fetchProducts = (eventID) => {
	return {
		type: FETCH_PRODUCTS,
		loading: true,
		eventID: eventID
	};
};

export const fetchProductsSuccess = (products, productsMeta) => {
	return {
		type: FETCH_PRODUCTS_SUCCESS,
		products: products,
		productsMeta: productsMeta,
		loading: false
	};
};

export const fetchProductsFail = (error) => {
	return {
		type: FETCH_PRODUCTS_FAIL,
		error: error,
		loading: false
	};
};

export const fetchProductCategories = () => {
	return {
		type: FETCH_PRODUCT_CATEGORIES,
		loadingCategories: true
	};
};

export const fetchProductCategoriesSuccess = (productCategories) => {
	return {
		type: FETCH_PRODUCT_CATEGORIES_SUCCESS,
		loadingCategories: false,
		productCategories: productCategories
	};
};

export const fetchProductCategoriesFail = (error) => {
	return {
		type: FETCH_PRODUCT_CATEGORIES_FAIL,
		loadingCategories: false,
		error: error
	};
};

export const fetchProduct = (productID) => {
	return {
		type: FETCH_PRODUCT,
		productID: productID,

	};
};

export const fetchProductSuccess = (product) => {
	return {
		type: FETCH_PRODUCT_SUCCESS,
		selectedProduct: product
	};
};

export const fetchProductFail = (error) => {
	return {
		type: FETCH_PRODUCT_FAIL,
		error: error,
		loading: false
	};
};

export const setProductSearchTerm = (searchTerm) => {
	return {
		type: SET_PRODUCT_SEARCH_TERM,
		searchTerm: searchTerm
	};
};

export const setProductQuantity = (productID, quantity, orderRowID) => {
	return {
		type: SET_PRODUCT_QUANTITY,
		productID: productID,
		quantity: quantity,
		orderRowID: orderRowID
	};
};


export const setSortBy = value => {
	return {
		type: SHOP_SORT_BY,
		value: value
	};
};


export const setSelectedProductCategory = productCategoryId => {
	return {
		type: SET_SELECTED_PRODUCT_CATEGORY,
		productCategoryId: productCategoryId
	};
};

export const fetchProductBundles = () => {
	return {
		type: FETCH_PRODUCT_BUNDLES
	};
};

export const fetchProductBundlesSuccess = () => {
	return {
		type: FETCH_PRODUCT_BUNDLES_SUCCESS
	};
};

